import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(theme => ({
   details: {
      zIndex: 10,
      cursor: 'pointer',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center'
   },
   detailList: {
      flexDirection: 'column',
      flexWrap: 'nowrap',
      background: '#fefefe',
      maxHeight: 100,
      overflowY: 'auto',
      padding: '0px 10px'
   },
   detailItem: {
      padding: 4,
      borderTop: '1px solid #eee7'
   },
   menu: {
      marginTop: 140
   },
   menuList: {
      padding: '0px 20px',
      height: 220
   }
}))
